export const construirPayloadListar = (filtros, paginacao) => ({
  codigo_grupo_empresa: filtros.codigoGrupoEmpresa,
  codigo_conta: filtros.codigoConta,
  data_inicio: filtros.dataInicio,
  data_fim: filtros.dataFim,
  tipo_data: filtros.tipoData,
  status: filtros.status,
  tipo_despesa: !!filtros.tipoDespesa,
  tipo_projeto: !!filtros.tipoProjeto,
  tipo_comissao: !!filtros.tipoComissao,
  tipo_sienge: !!filtros.tipoSienge,
  conferencia: filtros.conferencia,
  doc_nf: !!filtros.docNF,
  doc_guia: !!filtros.docGuia,
  doc_recibo: !!filtros.docRecibo,
  doc_nfs: !!filtros.docNFS,
  workflow: filtros.workflow,
  somente_workflow: !!filtros.somenteWorkflow,
  apenas_abertos: !!filtros.apenasAbertos,
  pagamentos_gestao_pessoas: !!filtros.pagamentosGestaoPessoas,
  rpa: !!filtros.rpa,
  mei: !!filtros.mei,
  mei_opcao: filtros.meiOpcao || 'todos',
  favorecido: filtros.favorecido || '',
  codigo_chave: filtros.codigoChave || null,
  codigo_usuario: filtros.codigoUsuario || null,
  codigo_departamento: filtros.codigoDepartamento || null,
  acao_usuario: filtros.acaoUsuario || null,
  order_by: paginacao && paginacao.orderBy ? paginacao.orderBy : 'Data',
  order_dir: paginacao && paginacao.orderDir ? paginacao.orderDir : 'DESC',
  page_size: paginacao && paginacao.pageSize ? paginacao.pageSize : 20,
  page_number: paginacao && paginacao.pageNumber ? paginacao.pageNumber : 1,
});
